
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";

import UserCommentsComponent from './UserComments';

export const UserComments = connect(
    () => {
        return (state, props) => ({
            comments: props.data,
        });
    },
    (dispatch, props) => ({
        actions: bindActionCreators({
        }, dispatch)
    })
)(injectIntl(UserCommentsComponent));